import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ToggleBoxBody = ({ show, children, classes, style }) => {
  return (
    <Fragment>
      {show && (
        <div
          className={`div-toggler-body${classes ? ` ${classes}` : ''}`}
          {...(style && { style })}
        >
          {children}
        </div>
      )}
    </Fragment>
  );
};

ToggleBoxBody.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  classes: PropTypes.string,
  style: PropTypes.object,
};

export default ToggleBoxBody;
